// Zet de methoden van losse "mixin"-klassen op een doelklasse, zodat een grote klasse over
// meerdere bestanden verdeeld kan worden. Bestaat een methode al, dan is dat een fout.
export function applyMixins(target, ...mixins) {
  for (const mixin of mixins) {
    for (const key of Object.getOwnPropertyNames(mixin.prototype)) {
      if (key === 'constructor') continue;
      if (Object.prototype.hasOwnProperty.call(target.prototype, key)) {
        throw new Error(`Methode ${key} bestaat al op ${target.name}`);
      }
      Object.defineProperty(target.prototype, key, Object.getOwnPropertyDescriptor(mixin.prototype, key));
    }
  }
}
